import type { FilterDefinition } from '../engine/types';
import { FilterId, type SingleValueFilter } from '../types/filters';
import {
  defineNumericTaxonomyFilter,
  type NumericTaxonomySelection,
} from './numericTaxonomy';

export type CustomSkillTaxonomySelection = NumericTaxonomySelection;

export const skillTaxonomyDescriptor = defineNumericTaxonomyFilter({
  id: FilterId.SKILL_TAXONOMY,
  name: 'Skill Taxonomy',
});

export const skillTaxonomyDefinition: FilterDefinition<
  SingleValueFilter<CustomSkillTaxonomySelection>
> = skillTaxonomyDescriptor.definition;
